module.exports = __webpack_public_path__ + "static/media/isotipo.045b615a.png";